var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.status === 2 && _vm.category)?_c('div',{staticClass:"NoDataDv"},[_c('NoData',{attrs:{"category":'coupon.gif'}})],1):_vm._e(),(_vm.status === 3)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }